import React from 'react';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import {
    Button,
    DialogActions,
    DialogTitle,
    InputLabel,
    Typography,
    withStyles,
    DialogContent,
    TextField,
    Grid,
    Tabs,
    Tab,
    ListItemText,
    List,
} from 'material-ui';
import {styles} from '../../style/staff_section';
import SimpleEditor from '../../../../components/editor/simple_editor';
import {SelectMultiple} from '../../../../components/fields/field_multi_select';
import SortableItem from '../../../../components/sortable/sortable_item';
import {TabContainer} from '../../../../components/tab/tab_container';
import _differenceBy from 'lodash/differenceBy';

class OverviewSectionEdit extends React.Component {
    state = {
        valueTab: 0,
    };

    handleTabChange = (event, value) => {
        this.setState({
            valueTab: value,
        });
    };

    render() {
        let {
            classes,
            onHandleSubmit,
            onHandleClose,
            onUpdateTitleField,
            title,
            allFeatures,
            body,
            onUpdateBodyField,
        } = this.props;
        let {
            selectedIncludedFeatures,
            selectedNotIncludedFeatures,
            setIncludedFeatures,
            setNotIncludedFeatures,
        } = this.props;
        let {valueTab} = this.state;
        let disableButton = false;

        if (selectedIncludedFeatures.length < 1) {
            disableButton = true;
        }

        if (selectedNotIncludedFeatures.length < 1) {
            disableButton = true;
        }

        let selectHasError = (selected, name) => {
            let selectError = {};

            if (selected === undefined) {
                selectError = {[name]: true};
                disableButton = true;
            } else {
                if (selected.toString().length < 1) {
                    selectError = {[name]: true};
                }

                if (selected.toString().length > 0) {
                    selectError = {[name]: false};
                }
            }

            return selectError[name];
        };

        let listItemsIncluded = selectedIncludedFeatures.map((feature, i) => {
            return (
                <SortableItem
                    key={i}
                    onSortItems={(includedItems) =>
                        setIncludedFeatures(includedItems)
                    }
                    items={selectedIncludedFeatures}
                    sortId={i}
                    className={classes.reviewsOrderItems}
                >
                    <ListItemText secondary={feature.display_name} />
                </SortableItem>
            );
        });

        let listItemsNotIncluded = selectedNotIncludedFeatures.map(
            (feature, i) => {
                return (
                    <SortableItem
                        key={i}
                        onSortItems={(notIncludedItems) =>
                            setNotIncludedFeatures(notIncludedItems)
                        }
                        items={selectedNotIncludedFeatures}
                        sortId={i}
                        className={classes.reviewsOrderItems}
                    >
                        <ListItemText secondary={feature.display_name} />
                    </SortableItem>
                );
            }
        );

        return (
            <EditDialog
                open={this.props.open}
                classes={{
                    paper: classes.overviewPaper,
                    fullWidth: classes.fullWidth,
                }}
            >
                <DialogTitle>Edit Project Overview Section</DialogTitle>

                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="title"
                        label="Title"
                        onChange={(event) => {
                            onUpdateTitleField(event.target.value);
                        }}
                        fullWidth
                        value={title || ''}
                    />

                    <InputLabel className="simpleEditorLabelPages">
                        Body
                    </InputLabel>
                    <SimpleEditor
                        initialValue={body}
                        onChange={(htmlBody) => {
                            onUpdateBodyField(htmlBody);
                        }}
                    />

                    <Tabs
                        value={valueTab}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this.handleTabChange}
                    >
                        <Tab value={0} label="Features" />
                        {selectedIncludedFeatures.length > 1 && (
                            <Tab value={1} label="Change 'Included' Order" />
                        )}
                        {selectedNotIncludedFeatures.length > 1 && (
                            <Tab
                                value={2}
                                label="Change 'Not Included' Order"
                            />
                        )}
                    </Tabs>

                    {valueTab === 0 && (
                        <TabContainer>
                            <Grid container>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subheading">
                                        Included *
                                    </Typography>
                                    <SelectMultiple
                                        id="1"
                                        label={'Included'}
                                        name="included"
                                        onItemsChange={setIncludedFeatures}
                                        selectedItems={selectedIncludedFeatures}
                                        items={_differenceBy(
                                            allFeatures,
                                            selectedNotIncludedFeatures,
                                            'id'
                                        )}
                                        labelKey={'display_name'}
                                        valueKey={'id'}
                                        InputProps={{required: true}}
                                    />
                                    {selectHasError(
                                        selectedIncludedFeatures,
                                        'included'
                                    ) ? (
                                        <Typography
                                            variant="caption"
                                            color="error"
                                        >
                                            Please select at least one value!
                                        </Typography>
                                    ) : (
                                        <Typography variant="caption">
                                            Select Included features from the
                                            drop-down
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subheading">
                                        Not Included *
                                    </Typography>
                                    <SelectMultiple
                                        id="2"
                                        label={'Not Included'}
                                        name="not_included"
                                        onItemsChange={setNotIncludedFeatures}
                                        selectedItems={
                                            selectedNotIncludedFeatures
                                        }
                                        items={_differenceBy(
                                            allFeatures,
                                            selectedIncludedFeatures,
                                            'id'
                                        )}
                                        labelKey={'display_name'}
                                        valueKey={'id'}
                                    />
                                    {selectHasError(
                                        selectedNotIncludedFeatures,
                                        'not_included'
                                    ) ? (
                                        <Typography
                                            variant="caption"
                                            color="error"
                                        >
                                            Please select at least one value!
                                        </Typography>
                                    ) : (
                                        <Typography variant="caption">
                                            Select Not Included features from
                                            the drop-down
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        </TabContainer>
                    )}

                    {valueTab === 1 && (
                        <TabContainer>
                            <List component="nav">{listItemsIncluded}</List>
                        </TabContainer>
                    )}

                    {valueTab === 2 && (
                        <TabContainer>
                            <List component="nav">{listItemsNotIncluded}</List>
                        </TabContainer>
                    )}
                    <Typography
                        variant="caption"
                        color="error"
                        style={{marginTop: 10}}
                    >
                        *Mandatory fields
                    </Typography>
                </DialogContent>

                <DialogActions className={classes.dialogActionsBtn}>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleClose(ev)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="raised"
                        disabled={disableButton}
                        onClick={(ev) => onHandleSubmit(ev)}
                        color="primary"
                    >
                        Done
                    </Button>
                </DialogActions>
            </EditDialog>
        );
    }
}

export default withStyles(styles)(OverviewSectionEdit);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/overview_popup_edit.js